// extracted by mini-css-extract-plugin
module.exports = {"header":"infoPOI_header__12Ete","image-wrapper":"infoPOI_image-wrapper__2Fkd1"};